import { TimeLine } from "@/components/apis/campaign";

type Props = {
    timeLine: TimeLine[];
};

export default function Timeline({ timeLine }: Props) {
    return (
        <div className="w-full h-[292px] relative overflow-x-hidden overflow-y-auto text-white">
            <div className="w-full left-[22px] top-0 absolute flex-col justify-start items-start gap-4 inline-flex">
                <div className="text-white text-xl font-semibold leading-7">
                    Timeline
                </div>
                <div className="flex-col justify-start items-start gap-8 flex overflow-y-auto">
                    {timeLine.map((item) => (
                        <div
                            className="flex-col justify-center items-start gap-2 flex"
                            key={`${item.time}-${item.title}`}
                        >
                            <div className="text-center text-white text-base font-medium leading-tight">
                                {item.title}
                            </div>
                            <p className="text-start text-zinc-400 text-sm leading-[20px] font-normal">
                                {item.time}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
            <div className="w-1.5 h-[166px] left-0 top-[51px] absolute opacity-20 flex-col justify-start items-center inline-flex">
                {timeLine.map((item, index) => (
                    <div key={`${item.title}-${item.time}`}>
                        <div className="w-1.5 h-1.5 bg-white rounded-full" />
                        {index < timeLine.length - 1 && (
                            <div className="w-px h-[74px] bg-white translate-x-[2px]" />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
